export default "__VITE_ASSET__27f98073__"